import * as THREE from 'three';

const followCameraInitComponent = {
  schema: {
    offset: { type: 'vec3', default: { x: 0, y: 0, z: -3 } }, // 2 units in front
  },
  tick: function () {
    const camera = document.querySelector('#camera').object3D;
    const target = this.el.object3D;

    // get camera world position and direction
    const cameraPos = new THREE.Vector3();
    camera.getWorldPosition(cameraPos);

    const cameraDir = new THREE.Vector3();
    camera.getWorldDirection(cameraDir);

    // apply offset (e.g., always 2 units in front of camera)
    const newPos = cameraPos
      .clone()
      .add(cameraDir.multiplyScalar(this.data.offset.z));

    // optionally apply x/y offset too
    newPos.x += this.data.offset.x;
    newPos.y = this.data.offset.y;
    newPos.z = -3;

    // update element position
    target.position.copy(newPos);
  },
};

export default followCameraInitComponent;
